export enum EMainRoutes {
	DASHBOARD = 'dashboard',
	CATALOG = 'catalog',
	OFFER = 'offer',
	OFFERS = 'offers',
	CONTRACTORS = 'contractors',
	BALANCE = 'balance',
	LEGAL_INFO = 'legal-info',
	REPORTS = 'reports',
	DOCUMENTS = 'documents',
	CLIENTS = 'clients',
	PORTFOLIO = 'portfolio',
	TASK = 'task',
	TASKS = 'tasks',

	EARNINGS = 'earnings',
	CREATE = 'create',
	EDIT = 'edit',
	PREVIEW = 'preview',

	PUBLISHER = 'publisher',
	ADVERTISER = 'advertiser',
	PUBLIC = 'public',
	ACCOUNT = 'account',
	NOTIFICATIONS = 'notifications',
	PROFILE = 'profile',
	LOG_IN= 'login',

	SOURCES = 'sources',
	MY_OFFERS = 'my-offers',
	REPORTS_CAP = 'reports-cap',
}
